import React from 'react';

export default function Spinner({ size = 20 }) {
  return (
    <span
      className="spinner"
      style={{ width: size, height: size }}
      aria-label="loading"
    />
  );
}

export function LoadingOverlay() {
  return (
    <div
      style={{
        position: 'fixed', inset: 0,
        background: 'var(--bg)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <Spinner />
    </div>
  );
}
